<div style="padding-top: 10px; clear: both;">
  <input #uploadFileInput type="file" class="custom-file-input" style="display: none;"
  (change)="whenFileSelect($event)" required />
</div>

<section [ngStyle]="{ background: 'inherit' }" [ngClass]="{ overrideCoreWithPanicMsg: isBurtAvailable }">
  <div *ngIf="isBurtAvailable">
    <input id="overrideCoreFileValidation" type="checkbox" [(ngModel)]="overrideUpload"  (ngModelChange)="overrideUploadChange.emit($event)" class="caseNumCheck__input" />
    <label class="caseNumCheck__label" for="overrideCoreFileValidation">
      <span style="color: #0067c5;">Override core file validation (optional)</span>
    </label>
  </div>
  <div id="panicErrorMessage" class="alert alert-danger" style="width: 100%; margin-top: 5px;"></div>
  <div *ngIf="overrideUpload" style="padding-top: 10px; clear: both;" id="override_upload">
    <label for="PMBTAEnterPwd" class="closestRegion__label">
      <span>Enter Password</span>
    </label>
    <input id="PMBTAEnterPwd"
           [(ngModel)]="overridePassword"
           (ngModelChange)="overridePasswordChange.emit($event)"
           class="sfu-form__custom_input" type="password"
           *ngIf="overrideUpload"
           (click)="pmbtaOverridePwdChange = true" />
  </div>
</section>

<div style="margin-top: 20px;">
  <span *ngIf="!ispmbtaUploadBtn" class="upload__label">{{'sfu_upload_files'| translate}}</span>
  <button *ngIf="!ispmbtaUploadBtn" class="button button--small" id="upload_button" (click)="uploadFileInput.click()"
    [disabled]="isDisabled" style="text-transform: none;">{{ 'sfu_upload_button_text' | translate }}</button>
</div>
<div style="padding-top: 10px; clear: both; margin-top: 20px;">
  <span *ngIf="ispmbtaUploadBtn" class="upload__label">
    {{ ('sfu_upload_files' | translate) }}
  </span>
  <button *ngIf="ispmbtaUploadBtn" class="button button--small"  id="override_upload_button"
    (click)="onUploadOverride()"
    style="text-transform: none;" [disabled]="isDisabled || !pmbtaOverridePwdChange">
    {{('sfu_upload_button_text' | translate) }}
  </button>
</div>
<label *ngIf="fileName" for="userfile" class="n-form__label file-name">
  <span style="color: #0067c5;">{{ 'sfu_file_name_label_text'| translate }}</span>
  <small>{{ fileName }}</small>
</label>
<div *ngIf="errorMsg" class="alert alert-danger">
  <strong>Error:</strong> {{ errorMsg | translate}}
</div>